import { ReactComponent as CyberLiabilitySVG } from '../../../assets/images/icons/product_icons/cyber_liability_icon.svg';

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const CyberLiabilityIcon = (props: any) => {
    return (
        <SvgIcon {...props} component={CyberLiabilitySVG} inheritViewBox />
        // <SvgIcon {...props}>
        //     <CyberLiabilitySVG />
        // </SvgIcon>
    );
};

export default CyberLiabilityIcon;